export default __webpack_public_path__ + "static/media/tune.5a98ad20.mp3";